module.exports = __webpack_public_path__ + "media/images/clube_03-df55e7ac6b902e538938c297f4cf3747.png";